import {styled} from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const ShimmerText = styled(Typography)(() => ({
    background: `
            linear-gradient(
              90deg,
              rgba(255,255,255,1) 0%,
              rgba(255,255,255,0.5) 50%,
              rgba(255,255,255,1) 100%
            )
          `,
    backgroundSize: '200% 100%',
    backgroundClip: 'text',
    fontWeight: '800',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    animation: 'shimmer 2s infinite',
    fontSize: '60px',

    '@keyframes shimmer': {
        '0%': {backgroundPosition: '200% 0'},
        '100%': {backgroundPosition: '-200% 0'},
    },
}));

export default ShimmerText;